import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { Device_MANUFACTURE_Interface, Empty_Device_MANUFACTURE_Interface } from 'src/app/Interface/Device_MANUFACTURE_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_KarshnasMasol_Interface, KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { DeviceMANUFACTUREService } from 'src/app/Service/DeviceMANUFACTURE/DeviceMANUFACTURE.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-CalibrationInPositionForm',
  templateUrl: './CalibrationInPositionForm.component.html',
  styleUrls: ['./CalibrationInPositionForm.component.scss']
})
export class CalibrationInPositionFormComponent implements OnInit {

  @Input() Calibration_Form_Id
  @Input() LetterRequestSchduleCustomer_Id
  @Output() OnBack_Calibration_Action = new EventEmitter<number>();
  Data_Seleted_Customer:Customer_List_Interface=Empty_Customer_List_Interface()

  Token:String=""
  page:number=0;
  page_MainList:number=0;
  
  Calibration_Form_Code:string=''


  Filter_CustomerName:string=''
  Filter_LetterCode:string=''
  Filter_LetterCode2:string=''


  constructor(
    private Customer_Service:CustomerService,
    private modalService: BsModalService,
    private Alerify:AlertifyService,
    private Device_Service:DeviceService,
    private Calibration_Service:CalibrationService,
    private route: ActivatedRoute,
    private Nav_Service:NavService,
    private Unit_Service:UnitService,
    private Device_MANUFACTURE:DeviceMANUFACTUREService,
    private DeviceBehfa_Service:DeviceBehfaService,
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
  ) { }

  ngOnInit() {
    localStorage.removeItem('Daro_User_Comment')
    this.Token=localStorage.getItem('Daro_User_Token');

    this.DeviceForm=new FormGroup({
      id:new FormControl(null),
      Device_Id:new FormControl(null),
      DeviceCode:new FormControl(''),
      DeviceSerial:new FormControl(''),
      Dsc:new FormControl(null),

      TEMPERATURE_MIN:new FormControl(null),
      TEMPERATURE_MAX:new FormControl(null),
      TEMPERATURE_Vahed_id:new FormControl("0"),

      RELATIVE_HUMIDITY_MIN:new FormControl(null),
      RELATIVE_HUMIDITY_MAX:new FormControl(null),
      RELATIVE_HUMIDITY_Vahed_id:new FormControl("0"),

      ATMOSPHERIC_PRESSURE_MIN:new FormControl(null),
      ATMOSPHERIC_PRESSURE_MAX:new FormControl(null),
      ATMOSPHERIC_PRESSURE_Vahed_id:new FormControl("0"),
    })

    this.Device_MANUFACTURE_FORM=new FormGroup({
      id :new FormControl(),
      MANUFACTURE:new FormControl(null,Validators.required),
      MODEL:new FormControl(null,Validators.required),
      RANGE_MIN:new FormControl(null,Validators.required),
      RANGE_MAX:new FormControl(null,Validators.required),
      RANGE_Vahed_id:new FormControl('0',Validators.required),
      RESOLUTION:new FormControl(null,Validators.required),
      RESOLUTION_Vahed_id:new FormControl('0',Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,1134).subscribe(
      data=>{

        if(this.Calibration_Form_Id>0)
        {
          this.OnInitail_Form(this.Calibration_Form_Id);
        }
        else{
          this.Calibration_Form_Id="0"
          this.ReadData_LetterRequestCustomer()
        }

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )



  }

  ngOnDestroy() {
    this.UnLockScheduleLetter()
  }

  UnLockScheduleLetter() {
    this.Calibration_Service.UnLockScheduleLetter(this.Token,this.LetterRequestSchduleCustomer_Id).subscribe(
      data=>{

      },error=>{

      }
    )
  }

  OnInitail_Form(id) {
    this.Calibration_Service.GetSingle(this.Token,id,this.LetterRequestSchduleCustomer_Id,0).subscribe(
      data=>{

        if (data['id'] == -1) {
          this.Alerify.ErrorMessage("Another user is registering a receipt for this decree. Try again later.")
          this.OnBack_Calibration_Action.emit(-1);
        }
        else {

          this.Selected_LetterRequestCustomer_Device_Interface = data['letterRequestCustomer_Device_Detail']
          this.Data_List_Calibration = data['device']
          this.UploadImageSrc_List = data['files']
          this.FormAdded_Dsc = data['dsc']
          var temp: Calibration_List_Interface = data['model']
          this.Calibration_Form_Code = temp.code

          this.Selected_DataList_LetterRequestCustomer.id = data['model']['letterRequestSchduleCustomer_Id']


          if (temp.status == "1") {
            this.OnSubmitForm_Finish = true
          }

          this.Data_Seleted_Customer.id = temp.customerId
          localStorage.setItem('Daro_User_Comment', JSON.stringify(this.Data_Seleted_Customer));
        }

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Read_Recipt_Letter_Info(){
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerCalibrationRecipt(this.Token,this.Selected_DataList_LetterRequestCustomer.id,true).subscribe(
      data=>{
        this.Calibration_Form_Id = Number(data['calibration_Id'])
        this.Calibration_Form_Code=data['calibration_Code']

        if(this.Calibration_Form_Id>0)
        {
          this.OnInitail_Form(this.Calibration_Form_Id);
        }
        else{
          this.Calibration_Service.LockScheduleLetter(this.Token,this.Selected_DataList_LetterRequestCustomer.id).subscribe(
            data=>{

              if (data['id'] == -1) {
                this.Alerify.ErrorMessage("Another user is registering a receipt for this decree. Try again later.")
                this.Data_Seleted_Customer.id=0
              }
            },error=>{

            }
          )
        }
      }
    )
  }

  //#region Instrument form

  DeviceForm:FormGroup;

  get_DeviceForm_id(){
    return this.DeviceForm.get('id') as FormControl;
  }

  get_DeviceForm_DeviceCode(){
    return this.DeviceForm.get('DeviceCode') as FormControl;
  }


  get_DeviceForm_DeviceSerial(){
    return this.DeviceForm.get('DeviceSerial') as FormControl;
  }

  get_DeviceForm_Dsc(){
    return this.DeviceForm.get('Dsc') as FormControl;
  }


  get_DeviceForm_TEMPERATURE_MIN(){
    return this.DeviceForm.get('TEMPERATURE_MIN') as FormControl;
  }

  get_DeviceForm_TEMPERATURE_MAX(){
    return this.DeviceForm.get('TEMPERATURE_MAX') as FormControl;
  }

  get_DeviceForm_TEMPERATURE_Vahed_id(){
    return this.DeviceForm.get('TEMPERATURE_Vahed_id') as FormControl;
  }

  get_DeviceForm_RELATIVE_HUMIDITY_MIN(){
    return this.DeviceForm.get('RELATIVE_HUMIDITY_MIN') as FormControl;
  }

  get_DeviceForm_RELATIVE_HUMIDITY_MAX(){
    return this.DeviceForm.get('RELATIVE_HUMIDITY_MAX') as FormControl;
  }

  get_DeviceForm_RELATIVE_HUMIDITY_Vahed_id(){
    return this.DeviceForm.get('RELATIVE_HUMIDITY_Vahed_id') as FormControl;
  }

  get_DeviceForm_ATMOSPHERIC_PRESSURE_MIN(){
    return this.DeviceForm.get('ATMOSPHERIC_PRESSURE_MIN') as FormControl;
  }

  get_DeviceForm_ATMOSPHERIC_PRESSURE_MAX(){
    return this.DeviceForm.get('ATMOSPHERIC_PRESSURE_MAX') as FormControl;
  }

  get_DeviceForm_ATMOSPHERIC_PRESSURE_Vahed_id(){
    return this.DeviceForm.get('ATMOSPHERIC_PRESSURE_Vahed_id') as FormControl;
  }


  //#endregion


  //#region Instrument

  modalRef_Device: any;
  copyLastRecord_DeviceBehfa_For_Device:boolean=false
  ProcssingDevice:boolean=false

  Search_Name_Device_Table:string=''
  Search_Code_Device_Table:string=''

  openModal_Device(template: TemplateRef<any>) {
    this.modalRef_Device = this.modalService.show(template);
    this.DataList_Device_Filtered=[]
  }

  DataList_Device:Array<LetterRequestCustomer_Device_Interface>=[]
  DataList_Device_Filtered:Array<LetterRequestCustomer_Device_Interface>=[]
  Data_Seleted_Record_LetterRequestCustomer_Device:LetterRequestCustomer_Device_Interface=Empty_LetterRequestCustomer_Device_Interface()


  ReadData_Device_KeySearch_Timer:any
  ReadData_Device_KeySearch(){

    if (this.ReadData_Device_KeySearch_Timer) {
      clearTimeout(this.ReadData_Device_KeySearch_Timer);
      this.ReadData_Device_KeySearch_Timer = null;
  }

  this.ReadData_Device_KeySearch_Timer = setTimeout(function (){
    this.ReadData_Device()
  }.bind(this), 1000);

  }

  ReadData_Device(){
    this.ProcssingDevice=true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerDeviceListDetail(
      0,
      this.Selected_DataList_LetterRequestCustomer.id,
      2,
      this.Token).subscribe(
      data=>{
        this.DataList_Device=data
        this.ProcssingDevice=false
        this.Filter_Selected_Device()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  Filter_Selected_Device(){

    this.DataList_Device_Filtered=[]
    for(let item of this.DataList_Device)
    {
      if(this.Check_Is_Exist__LetterRequestCustomer_Device_Interface(item.id)==false)
      {
        this.DataList_Device_Filtered.push(item)
      }
    }

  }

  Selected_LetterRequestCustomer_Device_Interface:Array<Number>=[]
  Set_Selected_Device_Record(item:LetterRequestCustomer_Device_Interface){
    this.Data_Seleted_Record_LetterRequestCustomer_Device=item
    //this.modalRef_Device.hide()

    if(this.Check_Is_Exist__LetterRequestCustomer_Device_Interface(item.id))
    {
      this.Alerify.ErrorMessage("The instrument already exists in the list.")
    }
    else{


      this.Selected_LetterRequestCustomer_Device_Interface.push(item.id)
      var temp:Calibration_Interface=Empty_Calibration_Interface();
      temp = {
        id:0,
        device_id:Number(this.Data_Seleted_Record_LetterRequestCustomer_Device.device_id),
        device_name:this.Data_Seleted_Record_LetterRequestCustomer_Device.device_name_en,
        kala_code:"",
        asteghrar:"",
        device_code:this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceCode+'',
        device_serial:this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceSerial+'',
        expiration:Number(item.expiration),
        expiration_title:'',
        dsc:this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceCustomerDsc+'',
        priority:item.id,
        priority_title:'',
        priod:0,
        parent:0,
        persianDate: '',
        canEditDetail:1,

        status: 1,
        expert_off:0,
        display_linearity:0,

        tEMPERATURE_MIN:0,
        tEMPERATURE_MAX:0,
        tEMPERATURE_Vahed_id:0,
        tEMPERATURE_Vahed_Title:'',

        rELATIVE_HUMIDITY_MIN:0,
        rELATIVE_HUMIDITY_MAX:0,
        rELATIVE_HUMIDITY_Vahed_id:0,
        rELATIVE_HUMIDITY_Vahed_Title:'',

        aTMOSPHERIC_PRESSURE_MIN:0,
        aTMOSPHERIC_PRESSURE_MAX:0,
        aTMOSPHERIC_PRESSURE_Vahed_id:0,
        aTMOSPHERIC_PRESSURE_Vahed_Title:'',
        labAdderss:'',
        visible:true,
        showDeviceBehfa:false,

        manufactureData:[],
        deviceBehfa:[],
        child:[],
      }

      if(this.copyLastRecord_DeviceBehfa_For_Device && this.Data_List_Calibration.length>0)
      {
        console.log(this.Data_List_Calibration.length);
        console.log(this.Data_List_Calibration[this.Data_List_Calibration.length-1].deviceBehfa);
        
        temp.deviceBehfa = this.Data_List_Calibration[this.Data_List_Calibration.length-1].deviceBehfa
      }

      this.Data_List_Calibration.push(temp)
      this.Alerify.SuccessMessage("The instrument was added to the list.")
      this.Filter_Selected_Device()
    }

  }

  Check_Is_Exist__LetterRequestCustomer_Device_Interface(id:Number)
  {
    for(let item of this.Selected_LetterRequestCustomer_Device_Interface)
    {
      if(item == id)
      {
        return true
      }
    }
    return false
  }

  Change_Calibration_Detail_State(item: Calibration_Interface,status:number)
  {
    item.status = status
  }

  //#endregion


  //#region Instrument table


  Data_List_Calibration:Array<Calibration_Interface>=[]

  Submit_DeviceForm(){

    if(this.Data_Seleted_Record_LetterRequestCustomer_Device.id==0)
    {
      this.Alerify.ErrorMessage("Select an instrument.")
    }

    else{

      this.Selected_LetterRequestCustomer_Device_Interface.push(this.Data_Seleted_Record_LetterRequestCustomer_Device.id)
      this.Filter_Selected_Device()
      if(this.List_Calibration_Edit_Id==-1)
      {
        var temp:Calibration_Interface=Empty_Calibration_Interface()
        temp.id=0

        temp.expiration = Number(this.Data_Seleted_Record_LetterRequestCustomer_Device.expiration)

        temp.device_id=Number(this.Data_Seleted_Record_LetterRequestCustomer_Device.device_id)
        temp.device_name=this.Data_Seleted_Record_LetterRequestCustomer_Device.device_name
        temp.kala_code=""
        temp.device_code=this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceCode+''
        temp.device_serial=this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceSerial+''
        temp.dsc=this.get_DeviceForm_Dsc().value

        temp.tEMPERATURE_MIN=Number(this.get_DeviceForm_TEMPERATURE_MIN().value)
        temp.tEMPERATURE_MAX=Number(this.get_DeviceForm_TEMPERATURE_MAX().value)
        temp.tEMPERATURE_Vahed_id=Number(this.get_DeviceForm_TEMPERATURE_Vahed_id().value)
        temp.tEMPERATURE_Vahed_Title=this.Find_Unit_Title(temp.tEMPERATURE_Vahed_id)

        temp.rELATIVE_HUMIDITY_MIN=Number(this.get_DeviceForm_RELATIVE_HUMIDITY_MIN().value)
        temp.rELATIVE_HUMIDITY_MAX=Number(this.get_DeviceForm_RELATIVE_HUMIDITY_MAX().value)
        temp.rELATIVE_HUMIDITY_Vahed_id=Number(this.get_DeviceForm_RELATIVE_HUMIDITY_Vahed_id().value)
        temp.rELATIVE_HUMIDITY_Vahed_Title=this.Find_Unit_Title(temp.rELATIVE_HUMIDITY_Vahed_id)

        temp.aTMOSPHERIC_PRESSURE_MIN=Number(this.get_DeviceForm_ATMOSPHERIC_PRESSURE_MIN().value)
        temp.aTMOSPHERIC_PRESSURE_MAX=Number(this.get_DeviceForm_ATMOSPHERIC_PRESSURE_MAX().value)
        temp.aTMOSPHERIC_PRESSURE_Vahed_id=Number(this.get_DeviceForm_ATMOSPHERIC_PRESSURE_Vahed_id().value)
        temp.aTMOSPHERIC_PRESSURE_Vahed_Title=this.Find_Unit_Title(temp.aTMOSPHERIC_PRESSURE_Vahed_id)

        temp.dsc=this.get_DeviceForm_Dsc().value

        this.Data_List_Calibration.push(temp)

      }
      else{

        this.Data_List_Calibration[this.List_Calibration_Edit_Id].device_id=Number(this.Data_Seleted_Record_LetterRequestCustomer_Device.device_id)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].device_name=this.Data_Seleted_Record_LetterRequestCustomer_Device.device_name
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].kala_code=""
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].device_code=this.get_DeviceForm_DeviceCode().value
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].device_serial=this.get_DeviceForm_DeviceSerial().value
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].dsc=this.get_DeviceForm_Dsc().value

        this.Data_List_Calibration[this.List_Calibration_Edit_Id].tEMPERATURE_MIN=Number(this.get_DeviceForm_TEMPERATURE_MIN().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].tEMPERATURE_MAX=Number(this.get_DeviceForm_TEMPERATURE_MAX().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].tEMPERATURE_Vahed_id=Number(this.get_DeviceForm_TEMPERATURE_Vahed_id().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].tEMPERATURE_Vahed_Title=this.Find_Unit_Title(this.Data_List_Calibration[this.List_Calibration_Edit_Id].tEMPERATURE_Vahed_id)

        this.Data_List_Calibration[this.List_Calibration_Edit_Id].rELATIVE_HUMIDITY_MIN=Number(this.get_DeviceForm_RELATIVE_HUMIDITY_MIN().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].rELATIVE_HUMIDITY_MAX=Number(this.get_DeviceForm_RELATIVE_HUMIDITY_MAX().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].rELATIVE_HUMIDITY_Vahed_id=Number(this.get_DeviceForm_RELATIVE_HUMIDITY_Vahed_id().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].rELATIVE_HUMIDITY_Vahed_Title=this.Find_Unit_Title(this.Data_List_Calibration[this.List_Calibration_Edit_Id].rELATIVE_HUMIDITY_Vahed_id)

        this.Data_List_Calibration[this.List_Calibration_Edit_Id].aTMOSPHERIC_PRESSURE_MIN=Number(this.get_DeviceForm_ATMOSPHERIC_PRESSURE_MIN().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].aTMOSPHERIC_PRESSURE_MAX=Number(this.get_DeviceForm_ATMOSPHERIC_PRESSURE_MAX().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].aTMOSPHERIC_PRESSURE_Vahed_id=Number(this.get_DeviceForm_ATMOSPHERIC_PRESSURE_Vahed_id().value)
        this.Data_List_Calibration[this.List_Calibration_Edit_Id].aTMOSPHERIC_PRESSURE_Vahed_Title=this.Find_Unit_Title(this.Data_List_Calibration[this.List_Calibration_Edit_Id].aTMOSPHERIC_PRESSURE_Vahed_id)

      }

      this.Data_Seleted_Record_LetterRequestCustomer_Device=Empty_LetterRequestCustomer_Device_Interface()
      this.List_Calibration_Edit_Id=-1
      /*
      this.DeviceForm.reset()
      this.get_DeviceForm_DeviceCode().setValue(tempDeviceCode)
      this.get_DeviceForm_Expiration().setValue(tempExpiration)

      this.get_DeviceForm_ATMOSPHERIC_PRESSURE_Vahed_id().setValue("0")
      this.get_DeviceForm_RELATIVE_HUMIDITY_Vahed_id().setValue("0")
      this.get_DeviceForm_TEMPERATURE_Vahed_id().setValue("0")
      */

    }

  }

  Delete_List_Calibration(id){
    var temp = this.Data_List_Calibration[id]
    this.Data_List_Calibration.splice(id,1)

    
    
    this.Selected_LetterRequestCustomer_Device_Interface.splice(this.Selected_LetterRequestCustomer_Device_Interface.indexOf(temp.priority),1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
    this.Filter_Selected_Device()
  }

  List_Calibration_Edit_Id:number=-1
  List_Calibration_Edit(id){
    this.List_Calibration_Edit_Id=id

    var temp=this.Data_List_Calibration[id]



    //this.Data_Seleted_Record.id=temp.device_id
    //this.Data_Seleted_Record.title=temp.device_name

    this.get_DeviceForm_DeviceCode().setValue(temp.device_code)
    this.get_DeviceForm_DeviceSerial().setValue(temp.device_serial)
    this.get_DeviceForm_Dsc().setValue(temp.dsc)

    this.get_DeviceForm_TEMPERATURE_MIN().setValue(temp.tEMPERATURE_MIN)
    this.get_DeviceForm_TEMPERATURE_MAX().setValue(temp.tEMPERATURE_MAX)
    this.get_DeviceForm_TEMPERATURE_Vahed_id().setValue(temp.tEMPERATURE_Vahed_id)

    this.get_DeviceForm_RELATIVE_HUMIDITY_MIN().setValue(temp.rELATIVE_HUMIDITY_MIN)
    this.get_DeviceForm_RELATIVE_HUMIDITY_MAX().setValue(temp.rELATIVE_HUMIDITY_MAX)
    this.get_DeviceForm_RELATIVE_HUMIDITY_Vahed_id().setValue(temp.rELATIVE_HUMIDITY_Vahed_id)

    this.get_DeviceForm_ATMOSPHERIC_PRESSURE_MIN().setValue(temp.aTMOSPHERIC_PRESSURE_MIN)
    this.get_DeviceForm_ATMOSPHERIC_PRESSURE_MAX().setValue(temp.aTMOSPHERIC_PRESSURE_MAX)
    this.get_DeviceForm_ATMOSPHERIC_PRESSURE_Vahed_id().setValue(temp.aTMOSPHERIC_PRESSURE_Vahed_id)
  }

  List_Calibration_Edit_Cancel(){
    this.List_Calibration_Edit_Id=-1
    this.DeviceForm.reset()
  }


  Visible_List_Calibration(item:Calibration_Interface){

    this.Calibration_Service.SetCalibrationDetailVisible(this.Token,item.id).subscribe(
      data=>{
        item.visible=!item.visible
        this.Alerify.SuccessMessage("Changes applied successfully.")
      }
    )
  }

  Change_Calibration_Show(item:Calibration_Interface){

    item.showDeviceBehfa=!item.showDeviceBehfa
  }

  //#endregion


  //#region Behfa equipment
  modalRef_DeviceBefa: any;
  Filter_Behfa_Item:string=''
  DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  Selected_Calibration_Record:Calibration_Interface=Empty_Calibration_Interface()
  //Selected_DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  Selected_DataList_DeviceBehfa_Record:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  order_DeviceBefa:string='id'
  orderreverse_DeviceBefa :boolean=true

  Filter_Behfa_description:string=''
  Filter_Behfa_manufacturer:string=''
  Filter_Behfa_model:string=''
  Filter_Behfa_codeBEHFA:string=''

  Procssing_DeviceBehfa:boolean=false
  ReadData_DeviceBehfa(){
    this.Procssing_DeviceBehfa=true
    this.DeviceBehfa_Service.GetRecordCalibration(this.Token,this.Selected_DataList_LetterRequestCustomer.id).subscribe(
      data=>{
        this.DataList_DeviceBehfa=data
        this.Procssing_DeviceBehfa=false

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal_DeviceBefa(template: TemplateRef<any>,item:Calibration_Interface) {
    this.modalRef_DeviceBefa = this.modalService.show(template);
    this.Selected_Calibration_Record=item
  }

  Set_Selected_DeviceBefa_Record(item){
    this.Selected_DataList_DeviceBehfa_Record=item
    //this.modalRef_DeviceBefa.hide()
    this.AddTo_DeviceBefa_List()
  }

  Delete_List_DeviceBehfa(id:number,item:Calibration_Interface){
    item.deviceBehfa.splice(id,1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
  }


  AddTo_DeviceBefa_List(){

    var CheckExisted:boolean=false

    for(let item of this.Selected_Calibration_Record.deviceBehfa)
    {
      if(item.id_temp==this.Selected_DataList_DeviceBehfa_Record.id_temp)
      {
        CheckExisted=true
        break
      }
    }

    if(this.Selected_DataList_DeviceBehfa_Record.id_temp==0)
    {
      this.Alerify.ErrorMessage(" No instrument has been selected.")
    }
    else if(CheckExisted)
    {
      this.Alerify.ErrorMessage("This instrument already exists in the list.")
    }
    else{
      this.Selected_Calibration_Record.deviceBehfa.push(this.Selected_DataList_DeviceBehfa_Record)
      this.Selected_DataList_DeviceBehfa_Record=Empty_DeviceBehfa_Interface()
      this.Alerify.SuccessMessage("Added to the list.")
    }
  }

  ChangeOrder_DeviceBefa(item:string)
  {
    this.order_DeviceBefa=item
    this.orderreverse_DeviceBefa=!this.orderreverse_DeviceBefa
  }

  //#endregion


  //#region Image
  BaseUrl = environment.BaseUrl
  UploadImageSrc_List: Array<General_Interface> = []
  UploadImageSrc: string = ''
  UploadImageDSc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.Calibration_Service.uploadFile(formData,this.Token).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alerify.ErrorMessage(data['filename'])
        }
        else {
          this.Alerify.SuccessMessage("File uploaded successfully.")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  Add_uploadImage1() {
    if (!this.UploadImageDSc || this.UploadImageDSc.trim().length < 50) {
      this.Alerify.ErrorMessage("Enter a description of at least 50 characters.")
    }
    else {
      var temp: General_Interface = Empty_General_Interface()
      temp.title = this.UploadImageSrc
      temp.code = this.UploadImageDSc
      this.UploadImageSrc_List.push(temp)
      this.UploadImageSrc = ''
      this.UploadImageDSc = ''
      this.Alerify.SuccessMessage("Added to the table.")
    }
  }

  UploadImageSrc_List_Delete(id: number) {
    this.UploadImageSrc_List.splice(id, 1)
    this.Alerify.SuccessMessage("Deleted successfully.")
  }

  modalRef_Image: any;
  ModalimageUrl: string = ''
  openModalImageZoom(template: TemplateRef<any>, imageUrl: string) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion

  //#region Remarks description
  FormAdded_Dsc: Array<string> = []
  FormAdded_Dsc_Input: string = ''

  FormAdded_Dsc_Delete(id) {
    this.FormAdded_Dsc.splice(id, 1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
  }

  FormAdded_Dsc_Submit() {
    if (!this.FormAdded_Dsc_Input) {
      this.Alerify.ErrorMessage("Enter the remark text.")
    }
    else {
      this.FormAdded_Dsc.push(this.FormAdded_Dsc_Input)
      this.FormAdded_Dsc_Input = ''
      this.Alerify.SuccessMessage('Information saved successfully.')
    }

  }

  //#endregion


  //#region Unit

  DataList_Unit:Array<Unit_Interface>=[]
  ReadData_Unit(){
    this.Unit_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_Unit=data
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Find_Unit_Title(id)
  {
      for(let item of this.DataList_Unit){
        if(item.id==id)
        {
          return item.title
        }
      }
      return ''
  }

  //#endregion


  //#region  Device MANUFACTURE
  Device_MANUFACTURE_FORM:FormGroup;
  modalRef_AddMANUFACTURE: any
  ProcssingMANUFACTURE:boolean=false
  modalRef_ShowManufaccure: any
  Filter_MANUFACTURE:String=''
  Device_MANUFACTURE_List:Array<Device_MANUFACTURE_Interface>=[]
  Selected_MANUFACTURE_Calibration_Indexer:number=-1

  get_Device_MANUFACTURE_FORM_Id(){
    return this.Device_MANUFACTURE_FORM.get('id') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_MANUFACTURE(){
    return this.Device_MANUFACTURE_FORM.get('MANUFACTURE') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_MODEL(){
    return this.Device_MANUFACTURE_FORM.get('MODEL') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RANGE_MIN(){
    return this.Device_MANUFACTURE_FORM.get('RANGE_MIN') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RANGE_MAX(){
    return this.Device_MANUFACTURE_FORM.get('RANGE_MAX') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RANGE_Vahed_id(){
    return this.Device_MANUFACTURE_FORM.get('RANGE_Vahed_id') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RESOLUTION(){
    return this.Device_MANUFACTURE_FORM.get('RESOLUTION') as FormControl;
  }

  get_Device_MANUFACTURE_FORM_RESOLUTION_Vahed_id(){
    return this.Device_MANUFACTURE_FORM.get('RESOLUTION_Vahed_id') as FormControl;
  }

  openModal_AddMANUFACTURE(template: TemplateRef<any>,item:number) {
    this.modalRef_AddMANUFACTURE = this.modalService.show(template);
    this.Selected_MANUFACTURE_Calibration_Indexer=item
  }

  openModal_ShowMANUFACTURE(template: TemplateRef<any>,item:number) {
    this.modalRef_ShowManufaccure = this.modalService.show(template);

    this.Selected_MANUFACTURE_Calibration_Indexer=item
    this.ReadData_MANUFACTURE()
  }

  ReadData_MANUFACTURE(){
    this.ProcssingMANUFACTURE=true
    this.Device_MANUFACTURE.GetCalibration(this.Token,this.Data_List_Calibration[this.Selected_MANUFACTURE_Calibration_Indexer].device_id).subscribe(
      data=>{
        this.Device_MANUFACTURE_List=data
        this.ProcssingMANUFACTURE=false
      }
    )
  }

  InProccessing_AddMANUFACTURE:boolean=false
  Submit_Device_MANUFACTURE_FORM(){

    var temp:Device_MANUFACTURE_Interface=Empty_Device_MANUFACTURE_Interface()
    temp.id=Number(this.get_Device_MANUFACTURE_FORM_Id().value)
    temp.mANUFACTURE=this.get_Device_MANUFACTURE_FORM_MANUFACTURE().value
    temp.mODEL=this.get_Device_MANUFACTURE_FORM_MODEL().value
    if(false){

    }
    else{
      this.InProccessing_AddMANUFACTURE=true
      this.Device_MANUFACTURE.AddDevice_MANUFACTURE(temp,this.Token).subscribe(
        data=>{
          this.InProccessing_AddMANUFACTURE=false
          if(data.id==-2)
          {
            this.Alerify.ErrorMessage("The entered manufacturer and model already exist for this instrument.")
          }
          else{
            temp.id=data.id
            this.Data_List_Calibration[this.Selected_MANUFACTURE_Calibration_Indexer].manufactureData.push(temp)
            this.Alerify.SuccessMessage("The manufacturer and model were added.")
            //this.modalRef_AddMANUFACTURE.hide()


          }
        }
      )
    }

  }

  Delete_List_MANUFACTURE(listIndex,id)
  {
    this.Data_List_Calibration[listIndex].manufactureData.splice(id,2)
    this.Alerify.SuccessMessage("Deleted successfully.")
  }

  Set_Selected_MANUFACTURE_Record(item,itemDetail){

    var Checker:boolean=false
    for(let itemDetail of this.Data_List_Calibration[this.Selected_MANUFACTURE_Calibration_Indexer].manufactureData)
    {
      if(itemDetail.id==item.id)
      {
        Checker=true
        break
      }
    }

    if(this.Data_List_Calibration[this.Selected_MANUFACTURE_Calibration_Indexer].manufactureData.length>0)
    {
      this.Alerify.ErrorMessage("The manufacturer and model have already been selected.")
    }
    else{
      this.Data_List_Calibration[this.Selected_MANUFACTURE_Calibration_Indexer].manufactureData.push(item)
      this.Data_List_Calibration[this.Selected_MANUFACTURE_Calibration_Indexer].manufactureData.push(itemDetail)
      this.Alerify.SuccessMessage("The manufacturer and model were added.")
    }
  }



  //#endregion


  //#region LetterRequestCustomer

  modalRef_LetterRequestCustomer: any;
  Procssing_LetterRequestCustomer:boolean=false
  Search_persianDate_LetterRequestCustomer:String=''
  Search_customer_LetterRequestCustomer:String=''
  Search_code_LetterRequestCustomer:String=''



  Show_Draft_LetterRequestCustomer:string='0'
  Selected_DataList_LetterRequestCustomer:LetterRequestCustomer_List_Interface=Empty_LetterRequestCustomer_List_Interface()
  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  ReadData_LetterRequestCustomer(){
    this.Procssing_LetterRequestCustomer=true
    this.DataList_LetterRequestCustomer=[]
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerCalibration_INLocation(this.Token,this.Show_Draft_LetterRequestCustomer=='1').subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data
        this.Procssing_LetterRequestCustomer=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )

  }

  Set_Selected_LetterRequestCustomer(item:LetterRequestCustomer_List_Interface){
    this.Selected_DataList_LetterRequestCustomer = item
    this.LetterRequestSchduleCustomer_Id=Number(item.id)
    this.Data_Seleted_Customer.id=Number(this.Selected_DataList_LetterRequestCustomer.customerId)
    this.Data_Seleted_Customer.name=this.Selected_DataList_LetterRequestCustomer.customer+''

    this.Selected_LetterRequestCustomer_Device_Interface=[]
    this.Data_List_Calibration=[]
    this.FormAdded_Dsc=[]
    this.UploadImageSrc_List=[]
    
    this.Read_Recipt_Letter_Info()
  }

  ChangeDraftClibrationReception(item:LetterRequestCustomer_List_Interface){
    this.Procssing_LetterRequestCustomer=true
    this.DataList_LetterRequestCustomer=[]
    this.LetterRequestCustomer_Service.ChangeDraftClibrationReception(this.Token,item.id,'',true).subscribe(
      data=>{
        this.Alerify.SuccessMessage("Information saved successfully.")
        this.ReadData_LetterRequestCustomer()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )

  }

  //#endregion


  //#region LetterRequestCustomer Cancel

  modalRef_Cancel: any
  Selected_DataList_LetterRequestCustomer_Canecl: LetterRequestCustomer_List_Interface = Empty_LetterRequestCustomer_List_Interface()
  Selected_Filter_Dsc:string=''

  LetterCustomer_Cancel(item:LetterRequestCustomer_List_Interface){

    this.modalRef_Cancel.hide()
    this.LetterRequestCustomer_Service.PostCancelMissionUser(Number(this.Selected_DataList_LetterRequestCustomer_Canecl.code2),
      this.Selected_Filter_Dsc,
      this.Token).subscribe(
      data=>{
        this.Alerify.SuccessMessage("The mission cancellation request was registered.")
        this.ReadData_LetterRequestCustomer()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal_LetterCustomer_Cancel(template: TemplateRef<any>,Record) {
    this.Selected_DataList_LetterRequestCustomer_Canecl=Record
    this.Selected_Filter_Dsc=''
    this.modalRef_Cancel = this.modalService.show(template);
  }

  //#endregion


  modalRef_Code: any;
  modalRef_FinishForm:any;

  openModal_FinishForm(template: TemplateRef<any>) {
    this.modalRef_FinishForm = this.modalService.show(template);
  }


  LabCustomerAddress:string=''

  OnSubmitForm_Finish:boolean=false
  Proccesing_SubmitForm:boolean=false
  OnSubmitForm(id,template: TemplateRef<any>)
  {
    if(id==1)
      this.modalRef_FinishForm.hide()


    var Check_UploadImageSrc_List:number=-1
    for (let item of this.UploadImageSrc_List)
    {
      if (!item.code || item.code.trim().length < 50) {
        Check_UploadImageSrc_List = this.UploadImageSrc_List.indexOf(item)
        break
      }
    }

    var Check_DeviceBehfa_List:number=-1
    for (let item of this.Data_List_Calibration)
    {
      if (item.status != 2 && item.deviceBehfa.length==0) {
        Check_DeviceBehfa_List = this.Data_List_Calibration.indexOf(item)
        break
      }
    }

    if (Check_UploadImageSrc_List > -1) {
      this.Alerify.ErrorMessage("Enter a description of at least 50 characters for attachment row "+(Check_UploadImageSrc_List+1)+".")
    }
    else  if (Check_DeviceBehfa_List > -1) {
      this.Alerify.ErrorMessage("No Behfa equipment has been selected for row "+(Check_DeviceBehfa_List+1)+".")
    }
    else {

      this.Proccesing_SubmitForm = true


      this.Calibration_Service.AddEditCalibration(
        this.Data_List_Calibration,
        [],
        this.UploadImageSrc_List,
        this.FormAdded_Dsc,
        0,
        this.Selected_DataList_LetterRequestCustomer.id,
        this.Data_Seleted_Customer.id,
        0,
        this.Calibration_Form_Id,
        true,
        "",
        "",
        id == 1,
        this.LabCustomerAddress,
        '',
        [],
        this.Token).subscribe(data => {

          if (data['id'] == -1) {
            this.Alerify.ErrorMessage(data['code']);
            this.Proccesing_SubmitForm = false
          }
          else {
            this.OnSubmitForm_Finish = (id == 1)
            this.Proccesing_SubmitForm = false

            this.Calibration_Form_Code = data['code']
            this.Calibration_Form_Id = data['id']

            this.OnInitail_Form(this.Calibration_Form_Id);

            this.modalRef_Code = this.modalService.show(template);
          }


        }, error => {
          localStorage.clear()
          location.reload();

        })
    }
  }

  OnSet_Back_CalibrationList(id: number) {

    if(this.Calibration_Form_Id || id==0)
      this.OnBack_Calibration_Action.emit(-1);
    else
    {
      this.UnLockScheduleLetter()
      this.Data_Seleted_Customer.id=0
    }
    localStorage.removeItem('Daro_User_Comment')
  }


}
